import { render, staticRenderFns } from "./SiteAside.vue?vue&type=template&id=ffea4eae&scoped=true&"
import script from "./SiteAside.vue?vue&type=script&lang=js&"
export * from "./SiteAside.vue?vue&type=script&lang=js&"
import style0 from "./SiteAside.vue?vue&type=style&index=0&id=ffea4eae&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea4eae",
  null
  
)

export default component.exports